import FormField from "../components/registration/FormField";

export default {
  props: {
    attribute: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    errorKeys: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  components: {
    FormField,
  },
};
